/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanEntitlementResponse
 */
export interface PlanEntitlementResponse {
    /**
     * 
     * @type {string}
     * @memberof PlanEntitlementResponse
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof PlanEntitlementResponse
     */
    quantityLimit?: number | null;
}

/**
 * Check if a given object implements the PlanEntitlementResponse interface.
 */
export function instanceOfPlanEntitlementResponse(value: object): value is PlanEntitlementResponse {
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function PlanEntitlementResponseFromJSON(json: any): PlanEntitlementResponse {
    return PlanEntitlementResponseFromJSONTyped(json, false);
}

export function PlanEntitlementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanEntitlementResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'quantityLimit': json['quantityLimit'] == null ? undefined : json['quantityLimit'],
    };
}

export function PlanEntitlementResponseToJSON(json: any): PlanEntitlementResponse {
    return PlanEntitlementResponseToJSONTyped(json, false);
}

export function PlanEntitlementResponseToJSONTyped(value?: PlanEntitlementResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'quantityLimit': value['quantityLimit'],
    };
}

